import type { FaireProductEntity } from "../../entity_types/product";

export const p_pkdtcx7vzy: FaireProductEntity = {
  token: "p_pkdtcx7vzy",
  type: "product",
  name: "Creamy Calabrian Marinara Pasta Sauce",
  brandToken: "b_3nxmfbpynu",
  brandName: "Ciao Pappy",
  imageUrl:
    "https://cdn.faire.com/fastly/d422a65a6b3855d9e7964b75a8602e323c1894243b1697512b5866636f1ce670.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/80c06fb36c4f854f88d59d69ee547ec7e613cf0049495f8bc94c026fa1e2f94d.png",
    "https://cdn.faire.com/fastly/73f8567d146b75ec6c0656d966cfebc3f5abc5d86523805141fe3023100d7662.png",
    "https://cdn.faire.com/fastly/a6892cba1bcc8f15ad02999821d4b404d3d447dc5139b73a64944c734059d80a.jpeg",
    "https://cdn.faire.com/fastly/b5973871aea49e9811f4b582e08009b28c1154a7652906d10af785897e3e2204.jpeg",
    "https://cdn.faire.com/fastly/5c48e0fb5f00ebbecb151f8039f4382d842f9ee7f203156531fa7b20da078fe7.jpeg",
    "https://cdn.faire.com/fastly/7a0dafb173fbc3eebaab2f5c01a8b0b8fd3f25a634ef019bf45d6fd4b9f914b8.png",
    "https://cdn.faire.com/fastly/4e853b6a4a54d416a5f7bd7006515284c3b195680572d0b0ce80661e7542272a.png",
    "https://cdn.faire.com/fastly/52709a6e014888a20004be5785ab0d88c7b2c9ebd7113b0e2d24023a61314fde.png",
  ],
  priceDollars: 8.75,
  description:
    "Elevate your dishes with our Creamy Calabrian Marinara, a harmonious blend of sun-ripened tomatoes and smoky Calabrian chili peppers. Versatile and delicious, it's perfect for pasta, pizza, and more! Discover a taste of the Calabrian coast in every jar.\n\nThis better-for-you, gluten free, non-GMO pasta sauce is perfect for spaghetti dinners, pizza, lasagna, chicken parmesan, or original recipes. Simple ingredients and low sugar make this authentic marinara sauce the ideal complement to any pasta dish.\n\nThis beautiful sauce has few quality ingredients, including crushed red tomatoes, organic cream, imported Calabrian chilis, and a pinch of sea salt. \n\n100% California tomatoes. No added sugar.\n\nBring this deliciousness to any summer BBQ or picnic!",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:31.823Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
